export default __webpack_public_path__ + "static/media/join-inner.f67d5509.svg";